export var ADMIN_TEMPLATE_VALUE = 'admin';
export var RECRUITMENT_PARTNER_TEMPLATE_VALUE = 'agent';
export var AUTOMATION_TEMPLATE_VALUE = 'automation';
export var ADMIN_TEMPLATE_OPTION = {
  value: ADMIN_TEMPLATE_VALUE,
  label: 'Admin Template'
};
export var RECRUITMENT_PARTNER_TEMPLATE_OPTION = {
  value: RECRUITMENT_PARTNER_TEMPLATE_VALUE,
  label: 'Recruitment Partner Template'
};
export var AUTOMATION_TEMPLATE_VALUE_OPTION = {
  value: AUTOMATION_TEMPLATE_VALUE,
  label: 'Road Runner (Automated) - No Regular Use'
};
export var TEMPLATE_TYPE_OPTIONS = [ADMIN_TEMPLATE_OPTION, AUTOMATION_TEMPLATE_VALUE_OPTION, RECRUITMENT_PARTNER_TEMPLATE_OPTION];
export var ARCHIVED_OPTIONS = [{
  value: '',
  label: 'All'
}, {
  value: 'true',
  label: 'Archived'
}, {
  value: 'false',
  label: 'Non Archived'
}];
export var DEFAULT_TEMPLATE_TYPE = ADMIN_TEMPLATE_VALUE;
export var DEFAULT_TEMPLATE_OPTION = ADMIN_TEMPLATE_OPTION;